import { request } from '@/shared/api/request'

const CONTROLLER = '/contract/econtract'
const TEENAGER = 'teenager'

export const getEtd = (payload) => {
	return request({ url: `${CONTROLLER}/get`, method: 'GET', params: payload })
}

export const getEtdEdit = (payload) => {
	return request({ url: `${CONTROLLER}/edithtml`, method: 'GET', params: payload })
}

export const sendtoEmployee = (payload) => {
	return request({ url: `${CONTROLLER}/send`, method: 'POST', params: payload })
}

export const declineEmployee = (payload) => {
	return request({ url: `${CONTROLLER}/employee/reject`, method: 'POST', params: payload })
}

export const sendForImprovementEmployee = (payload) => {
	return request({ url: `${CONTROLLER}/employee/sendForImprovement`, method: 'POST', params: payload })
}

export const declineEmployer = (payload) => {
	return request({ url: `${CONTROLLER}/employer/reject`, method: 'POST', params: payload })
}

export const revertEmployer = (payload) => {
	return request({ url: `${CONTROLLER}/employer/revert`, method: 'POST', params: payload })
}

export const deleteEtd = (payload) => {
	return request({ url: `${CONTROLLER}/delete`, method: 'DELETE', params: payload })
}

export const downloadPDF = (externalId) => {
	return request({ url: `${CONTROLLER}/pdf/?externalId=${externalId}`, method: 'GET', responseType: 'blob' })
}

export const getOptions = () => {
	return request({ url: `${CONTROLLER}/dict/options`, method: 'GET' })
}

export const saveProject = (payload, params) => {
	return request({ url: `${CONTROLLER}/save`, method: 'POST', data: payload, params: params })
}

export const requestFlData = (payload) => {
	return request({ url: `${CONTROLLER}/requestFlData`, method: 'GET', params: payload })
}

export const getStatusKdpFamilyForEmployee = (params) => {
	return request({ url: `${CONTROLLER}/${TEENAGER}/statusKdpFamily`, method: 'GET', params })
}

export const sendKdpFamily = (params) => {
	return request({ url: `${CONTROLLER}/${TEENAGER}/sendKdpFamily`, method: 'POST', params })
}

export const sendSmsConsent = (params) => {
	return request({ url: `${CONTROLLER}/${TEENAGER}/sendSmsConsent`, method: 'POST', params })
}

export const verifySmsConsent = (params) => {
	return request({ url: `${CONTROLLER}/${TEENAGER}/verifySmsConsent`, method: 'POST', params })
}

export const getXmlForRole = (params, payload) => {
	return request({ url: `${CONTROLLER}/${payload.role}/xml`, method: 'GET', params })
}

export const saveSign = (params, payload) => {
	return request({ url: `${CONTROLLER}/${payload.role}/saveSign`, method: 'POST', data: params })
}
